import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import SelectInput from "../../components/FormFields/SelectInput";
import CustomButton from "../../components/CustomButton";
import DatePicker from "../../components/FormFields/DatePicker";
import { Form, Formik } from "formik";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { raiseRequestValidation } from "../../utils/validations/raiseRequest";
import { numberToWords, sendToDBDateFormat } from "../../utils/helpers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import RadioButton from "../../components/FormFields/RadioButtons";

const RaiseARequest = () => {
  const { data = {}, apiCall } = useApi();
  const { apiCall: submitCall } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    apiCall({
      url: apiUrls.dmsService.getVoucherHeads,
      method: "get",
      processData: (apiData = []) => {
        const headOptions = [
          { key: "Please Select", value: "" },
          ...apiData?.map((item) => {
            // subHeadOptions[item?.headName] = [
            //   { key: "Please Select", value: "" },
            //   ...item?.voucherSubHeads.map((subHead) => ({
            //     key: subHead?.subHeadName,
            //     value: subHead?.subHeadName,
            //   })),
            // ];
            return {
              key: item?.headName,
              value: item?.headName,
            };
          }),
        ];
        return { headOptions };
      },
    });
  }, []);

  const onSubmitRequest = (values) => {
    const dataToSend = {
      dataModalAttributeSet: [
        {
          metadataTechnicalName: "date",
          attributeValue: moment(values?.date).format(sendToDBDateFormat),
        },
        { metadataTechnicalName: "head", attributeValue: values?.head },
        // { metadataTechnicalName: "sub_head", attributeValue: values?.sub_head },
        {
          metadataTechnicalName: "description",
          attributeValue: values?.description,
        },
        { metadataTechnicalName: "quantity", attributeValue: values?.quantity },
        { metadataTechnicalName: "rate", attributeValue: values?.rate },

        { metadataTechnicalName: "tax", attributeValue: values?.tax },
        { metadataTechnicalName: "amount", attributeValue: values?.amount },
      ],
      metadataSchemaId: 13,
    };

    submitCall({
      url: apiUrls.dmsService.createRecord,
      dataToSend,
      method: "post",
      onSuccess: () => {
        toast.success("Request has been submitted successfully");
        navigate(-1);
      },
    });
  };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Raise A Request"
        showBack
        containerClassName="mt-14"
      />
      <Formik
        enableReinitialize
        initialValues={{
          date: new Date(),
          head: "",
          // sub_head: "",
          description: "",
          quantity: "",
          rate: "",
          tax: "With Tax",
          amount: "",
        }}
        validationSchema={raiseRequestValidation}
        onSubmit={onSubmitRequest}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form>
              <div className="bg-[var(--whiteColor)] rounded-[1rem] mt-6 p-8 flex flex-col gap-y-4">
                <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Date:
                  </div>
                  <DatePicker
                    datePickerClassName="w-[41rem]"
                    datePickerTextClassName="text-[var(--textGray2)]"
                    onChange={(date) => {
                      setFieldValue("date", date);
                    }}
                    startDate={values.date}
                    error={touched.date && errors.date}
                    selectClassName="!max-w-[18rem]"
                    maxDate={new Date()}
                  />
                </div>
                <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Request Head:
                  </div>
                  <SelectInput
                    options={data?.headOptions}
                    wrapperClassName="!w-[41rem]"
                    onChange={(e) => {
                      setFieldValue("head", e);
                    }}
                    value={values.head}
                    error={touched.head && errors.head}
                  />
                </div>
                {/* <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Request Sub-Head:
                  </div>
                  <SelectInput
                    options={data?.subHeadOptions?.[values?.head]}
                    wrapperClassName="!w-[41rem]"
                    selectClassName="!mt-0"
                    onChange={(e) => {
                      setFieldValue("sub_head", e);
                    }}
                    value={values.sub_head}
                    error={touched.sub_head && errors.sub_head}
                  />
                </div> */}
                <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Description:
                  </div>
                  <InputWithIcon
                    containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !w-[41rem] !h-[5rem]"
                    onChange={(e) => {
                      setFieldValue("description", e);
                    }}
                    value={values.description}
                    error={touched.description && errors.description}
                  />
                </div>
                <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Quantity:
                  </div>
                  <InputWithIcon
                    containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !w-[9rem] !h-[5rem]"
                    onChange={(e) => {
                      setFieldValue("quantity", e);
                      if(Number(values.rate) && e){
                        setFieldValue(
                          "amount",
                          Number(values.rate) * Number(e)
                        );
                      }
                    }}
                    value={values.quantity}
                    error={touched.quantity && errors.quantity}
                    type="number"
                  />
                </div>
                <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Rate (₹):
                  </div>
                  <InputWithIcon
                    containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !w-[9rem] !h-[5rem]"
                    onChange={(e) => {
                      setFieldValue("rate", e);
                      if (values.quantity && e) {
                        setFieldValue(
                          "amount",
                          Number(values.quantity) * Number(e)
                        );
                      }
                    }}
                    value={values.rate}
                    error={touched.rate && errors.rate}
                    type="number"
                  />
                  <div className="text-[1.2rem] text-[var(--textGray4)] ml-3">
                    Per item
                  </div>
                </div>
                {/* <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Tax:
                  </div>
                  <div className="flex items-center gap-x-5 my-4">
                    <RadioButton
                      title="With Tax"
                      value="With Tax"
                      checked={values.tax === "With Tax"}
                      onChange={(e) => {
                        setFieldValue("tax", e.target.value);
                      }}
                    />
                    <RadioButton
                      title="Without Tax"
                      value="Without Tax"
                      checked={values.tax === "Without Tax"}
                      onChange={(e) => {
                        setFieldValue("tax", e.target.value);
                      }}
                    />
                  </div>
                </div> */}
                <div className="flex items-center">
                  <div className="font-size-medium text-[var(--blackColor)] w-[18rem]">
                    Total Amount (₹):
                  </div>
                  <InputWithIcon
                    containerClassName="!bg-[#F0F0F0] !w-[9rem] !h-[5rem]"
                    value={values.amount}
                    disabled
                  />
                  {values?.amount ? (
                    <div className="text-[1.2rem] text-[var(--textGray4)] ml-3">
                      ({numberToWords(values.amount)})
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-between mt-8">
                <CustomButton
                  title="Discard"
                  wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
                  onClick={() => {
                    navigate(-1)
                  }}
                />
                <CustomButton
                  title="Send Request"
                  wrapperClassName="!px-8"
                  type="submit"
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default RaiseARequest;
